import { React, useEffect, useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Skeleton from '../Skeleton';
import { Container } from './styles';

const Statistics = ({ icon, name, nullIcon = false, stringValue, chartIcon, value, text }) => {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (stringValue === '00hs00mins' || stringValue === '0') {
      setLoading(true)
    }
    if (stringValue !== '00hs00mins' || stringValue !== '0') {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [stringValue])

  return (
    <Container>

      {icon && (
        <>
          {loading ? (
            <div className="loading">
              <Skeleton circle={true} height={48} width={48} />
              <Skeleton height={20} width={90} />
              <Skeleton height={20} width={90} />
            </div>
          ) : (
            <>
              <img src={icon} alt="" />
              <h3>{stringValue}</h3>
              <strong>{name}</strong>
            </>
          )}
        </>
      )}

      {chartIcon && (
        <>
          {loading ? (
            <div className="loading">
              <Skeleton circle={true} height={48} width={48} />
              <Skeleton height={20} width={90} />
              <Skeleton height={20} width={90} />
            </div>
          ) : (
            <>
              <div className="progress-bar">
                <CircularProgressbar
                  value={value}
                  text={text}
                  strokeWidth={5}
                  styles={buildStyles({
                    textSize: '28px',
                    trailColor: 'rgb(120, 129, 152)',
                    pathColor: `rgb(33, 80, 141)`,
                  })}
                />
                {!text &&
                  <>
                    <img src={chartIcon} alt={name} />

                  </>
                }
              </div>
              <h3>{stringValue}</h3>
              <strong>{name}</strong>
            </>
          )}
        </>
      )}

      {nullIcon &&
        <>
          {loading ? (
            <div className="loading">
              <Skeleton circle={true} height={48} width={48} />
              <Skeleton height={20} width={90} />
              <Skeleton height={20} width={90} />
            </div>
          ) :
            (<>
              <h3>{stringValue}</h3>
              <strong>{name}</strong>
            </>)
          }
        </>
      }


    </Container>
  );
}

export default Statistics;